/**
 * @file NotificationTemplateSmsTab.js
 * @description SMS content tab for the multitenant notification template editor.
 */
import { CharacterLimitIndicator } from '../../helpers/CharacterLimitIndicator';
import RichTextEditor from '../../new-portal-page/RichTextEditor';
import { htmlToPlainText } from '../../../utils/htmlText';

const SMS_MAX_CHARS = 15000;

const NotificationTemplateSmsTab = ({
    initialPlainTextBody,
    currentPlainTextBody,
    onPlainTextBodyChange,
    isReadOnly,
    agencyId = null,
}) => {
    return (
        <div>
            <div
                style={{
                    opacity: isReadOnly ? 0.6 : 1,
                    pointerEvents: isReadOnly ? 'none' : 'auto',
                }}
            >
                <RichTextEditor
                    initialContent={initialPlainTextBody}
                    onContentUpdate={onPlainTextBodyChange}
                    disableFontStyling={true}
                    disableParagraphStyling={true}
                    disableImage={true}
                    disableVideo={true}
                    disableQRCode={true}
                    disableTable={true}
                    onAssetDelete={null}
                    plainTextLinksOnly={true}
                    disableSSO={true}
                    disablePortalLink={true}
                    disableMenu={true}
                    disableAssetLink={true}
                    agencyId={agencyId}
                />
            </div>
            <CharacterLimitIndicator
                maxChars={SMS_MAX_CHARS}
                inputStr={htmlToPlainText(currentPlainTextBody || '')}
            />
        </div>
    );
};

export default NotificationTemplateSmsTab;
